import { createAsyncThunk } from '@reduxjs/toolkit';
import store from '../..';
import ApiaApi from '../../../api/apiaApi/apiaApi';
import { notify } from '../../../components/common/notifications/util';
import { noNaN } from '../../../utils/util';
import { makeGridActionUrl } from '../actionsUtils';
import { TApiaXMLResponse, TDataGridThunkState } from '../types';
import { shouldDebugGridActions } from './add';
import { TRowActionResponse } from './types';

export function getSelectedRowsForSortEvent(gridId: string) {
  const state = store.getState().dataGridSlice[gridId];
  const sortedSelectedRows = [...state.selectedRows].sort((a, b) => b - a);
  const gridField = state.context.grid.field;
  const selectedRows = sortedSelectedRows.map(
    (index) => index + noNaN(gridField.startIndex),
  );
  return selectedRows;
}

const up = createAsyncThunk<
  TRowActionResponse | null,
  {
    gridId: string;
  },
  TDataGridThunkState
>('dataGridSlice/rowUp', async ({ gridId }, thunkApi) => {
  const state = thunkApi.getState().dataGridSlice[gridId];
  const gridField = state.context.grid.field;
  const currentPage = noNaN(gridField.curPage);
  const isPaged = gridField.properties.paged;
  const gridSize =
    isPaged && gridField.properties.pagedGridSize === undefined
      ? 5
      : Number(gridField.properties.pagedGridSize);
  const rowId = getSelectedRowsForSortEvent(gridId);
  const startIndex = noNaN(gridField.startIndex);
  const isFirstSelected = rowId[0] - startIndex === 0 && currentPage !== 0;
  const result = await ApiaApi.post<TApiaXMLResponse>(
    makeGridActionUrl({
      gridAction: 'up',
      context: state.context,
      rowId,
    }),
  );
  if (shouldDebugGridActions) console.log('up', result?.data);
  if (result?.data)
    return {
      xmlResponse: result?.data,
      focusRow: isFirstSelected ? gridSize : state.focusedRow - 1,
      newSelectedRows: isFirstSelected
        ? [gridSize]
        : state.selectedRows.map((current) => current - 1),
    };
  notify({
    message: 'Error on DataGrid action',
    type: 'danger',
  });
  return null;
});

export default up;
